import { render } from "./Home.vue?vue&type=template&id=033f72ed"
const script = {}
script.render = render

export default script